import { composeFilters } from '@iheartjane/menu';

import { useGoldFacets } from '@jane/search/data-access';
import { AlgoliaGoldFacetsSchema } from '@jane/search/types';
import { buildSearchFilter } from '@jane/search/util';

import { useBrandSpecials } from '../BrandSpecialsProvider/BrandSpecialsProvider';
import { useSearchContext } from '../SearchProvider';

interface UseGoldFacetFiltersProps {
  goldFacetsEnabled: boolean;
  staticFilters: string | undefined;
}

/**
 * This hook provides a shared way to determine facets and filters that will yeild the correct
 * Jane Gold results based on store settings and user segmentation.
 */
export const useGoldFacetsAndFilters = ({
  goldFacetsEnabled,
  staticFilters,
}: UseGoldFacetFiltersProps) => {
  const { searchState, indexPrefix } = useSearchContext();
  const { brandSpecialFilter, brandSpecials } = useBrandSpecials();

  const goldFacetsStaticFilters = composeFilters(
    staticFilters,
    brandSpecialFilter
  );

  const goldFacetsSearchFilters = buildSearchFilter({
    searchState,
    staticFilters: goldFacetsStaticFilters,
  });

  const { data: goldFacets } = useGoldFacets({
    enabled: goldFacetsEnabled && brandSpecials?.length > 0,
    indexPrefix,
    schemaObject: AlgoliaGoldFacetsSchema,
    staticFilters: goldFacetsStaticFilters,
    requestedFacets: ['has_brand_discount'],
    ...searchState,
  });

  return { goldFacetsSearchFilters, goldFacets };
};
